module.exports = __webpack_public_path__ + "img/WIN-YOG-INDO.0a4f4f24.jpg";